






















import Vue, { PropType } from 'vue';
import moment from 'moment';
import { DynamicDocumentItem, DynamicDocumentItemData } from '@/types';

export default Vue.extend({
  props: {
    item: {
      type: Object as PropType<DynamicDocumentItem>,
    },
    data: Object as PropType<DynamicDocumentItemData>,
  },

  data() {
    return {
      modal: false,
      date: new Date().toISOString().substr(0, 10),
    };
  },

  computed: {
    localeDate(): string {
      return moment(this.date).format('DD-MM-YYYY');
    },

    hideAnsweredQuestions(): boolean {
      return this.$store.state.ui.hideAnsweredQuestions;
    },
  },

  watch: {
    item: {
      immediate: true,
      handler(val) {
        this.date = this.data?.value as string;
      },
    },
  },

  methods: {
    save() {
      this.data.value = this.date;
      this.$emit('save:document');
      this.modal = false;
    },
  },
});
